import { styled, css } from 'styled-components'

import { DEVICE_SIZE } from 'utils/constants'

const getColorGrade = ({ grade }) => {
  const emptyValue = '-'
  let colors = ''

  switch (grade !== emptyValue ? Math.floor(grade) : grade) {
    case 10:
    case 9:
      colors = css`
        background-color: var(--grade-LightGreen4);
        border: solid 1px var(--grade-Green4);
        color: var(--grade-Green4);
      `
      break
    case 8:
    case 7:
      colors = css`
        background-color: var(--grade-LightGreen3);
        border: solid 1px var(--grade-Green3);
        color: var(--grade-Green3);
      `
      break
    case 6:
      colors = css`
        background-color: var(--grade-LightGreen2);
        border: solid 1px var(--grade-Green2);
        color: var(--grade-Green2);
      `
      break
    case 5:
      colors = css`
        background-color: var(--grade-LightGreen1);
        border: solid 1px var(--grade-Green1);
        color: var(--grade-Green1);
      `
      break
    case '-':
      colors = css`
        background-color: var(--silver);
        border: solid 1px var(--text-gray);
      `
      break

    default:
      colors = css`
        background-color: var(--grade-LightRed);
        border: solid 1px var(--grade-Red);
        color: var(--grade-Red);
      `
      break
  }
  return colors
}

export const Title = styled.h2`
  color: var(--dark-red);
  font-size: 30px;
  @media (max-width: ${DEVICE_SIZE.LAPTOP}) {
    font-size: 25px;
  }
`

export const GradeAvatar = styled.span`
  align-items: center;
  border-radius: 50%;
  display: flex;
  font-family: var(--fontRegular);
  font-size: 22px;
  height: 50px;
  justify-content: center;
  line-height: 1.5;
  max-width: 96px;
  opacity: 0.7;
  text-align: center;
  width: 50px;
  ${({ grade }) => getColorGrade({ grade })};
`
